module.exports = __webpack_public_path__ + "img/Speaker=Daryl Senick.1ec29b2e.png";